import React from 'react';
import { getElementFields } from '../../forms/utils/getElementFields';
import { SmartformElementData } from '../../types';
import { DatePicker } from '../../fields/DatePicker';

export const DateElement: React.FC<SmartformElementData> = (props) => {
  const [dateField] = getElementFields(props).required;
  const {
    name,
    helpText,
    label,
    validation: { required },
    error
  } = dateField;
  const minDateValue: Date | undefined = (props.dependentValues?.[0] as Date | null) ?? undefined;
  const maxDateValue: Date | undefined = (props.dependentValues?.[1] as Date | null) ?? undefined;
  return (
    <DatePicker
      name={name}
      key={name}
      helpText={helpText as any}
      label={label as any}
      required={required}
      infoText={dateField.infoText}
      errors={error}
      minDate={dateField.validation.minDate || minDateValue}
      minDateMessage={dateField.validation.minDateMessage}
      maxDate={dateField.validation.maxDate || maxDateValue}
      maxDateMessage={dateField.validation.maxDateMessage}
      dateFormat={props.element.params?.dateFormat}
      onChange={(value, setValue) => {
        setValue(value);
      }}
    />
  );
};
